/* eslint-disable */
import base from './configService'
import axios from 'axios';

const globalService = {}

globalService.getConfig = function () {
    return axios.get('/config/config.json')
        .then(res => {
            return res.data;
        })
        .catch(e => {
            return Promise.reject(error);
        })
}

globalService.getFaqs = function () {
    return axios.get('/config/faqs.json')
        .then(res => {
            return res.data;
        })
        .catch(e => {
            return Promise.reject(error);
        })
}

globalService.getVersion = function () {
    base.defaults.baseURL = window.urlApi;
    return base.get('/version')
        .then(res => {
            return res.data;
        })
        .catch(e => {
            return Promise.reject(error);
        })
}

globalService.getEmpresas = function () {
    base.defaults.baseURL = window.urlApi;
    // Hacer la llamada a la api
    return base.get('/Enterprises').then(res => {      
        if (!!res.data) {
            
            return res.data;
        } else {
            return false;
        }
        })
        .catch(e => {
        return Promise.reject(e);
    });
}

export default globalService